import React, { createContext, useContext, useEffect, useState } from 'react';

const ModoContext = createContext({ modo: 0, setModo: () => {} });

export function ModoProvider({ children }) {
  const [modo, setModo] = useState(() => {
    const saved = localStorage.getItem('modo');
    return saved ? parseInt(saved, 10) || 0 : 0;
  });

  useEffect(() => {
    localStorage.setItem('modo', String(modo));
  }, [modo]);

  return (
    <ModoContext.Provider value={{ modo, setModo }}>
      {children}
    </ModoContext.Provider>
  );
}

export function useModo() {
  return useContext(ModoContext);
}